import { Grid, List } from '@mui/material';
import React, { FC } from 'react';
import CollectiveInvoicesItem from '../collective-invoices-item/collective-invoices-item.component';

type CollectiveInvoicesListProps = {
    selectedClinics: { [key: string]: string };
    onClinicRemove: (clinicName: string) => void;
};

const CollectiveInvoicesList: FC<CollectiveInvoicesListProps> = ({
    selectedClinics,
    onClinicRemove,
}: CollectiveInvoicesListProps) => {
    return (
        <Grid item xs={12}>
            <List>
                {Object.keys(selectedClinics).map((clinicId, index) => {
                    return (
                        <CollectiveInvoicesItem
                            onClinicRemove={onClinicRemove}
                            clinicId={clinicId}
                            key={index}
                            clinicName={selectedClinics[clinicId]}
                        />
                    );
                })}
            </List>
        </Grid>
    );
};

export default CollectiveInvoicesList;
